(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    var node = root.querySelector('[data-jjt-kit-data]');
    var data;
    try { data = JSON.parse(node.textContent); } catch (_) { return; }
    if (!data.source.variants.length || !data.partners.length) return;
    root.dataset.ready = 'true';
    var source = root.querySelector('[data-jjt-kit-source]');
    var product = root.querySelector('[data-jjt-kit-product]');
    var partner = root.querySelector('[data-jjt-kit-partner]');
    var add = root.querySelector('[data-jjt-kit-add]');
    var status = root.querySelector('[data-jjt-kit-status]');
    var total = root.querySelector('[data-jjt-kit-total]');
    var shipping = root.querySelector('[data-jjt-kit-shipping]');
    var busy = false;
    var uncertain = false;
    var controls = [];
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function money(value) { return new Intl.NumberFormat(data.locale || 'en', {style:'currency',currency:data.currency}).format(value / 100); }
    function fillSizes(select, variants) {
      select.replaceChildren(new Option(data.copy.choose, ''));
      variants.forEach(function (v) { select.add(new Option(v.title + ' · ' + money(v.price), String(v.id))); });
    }
    function selection() {
      return [data.source.variants.find(function (v) { return String(v.id) === source.value; }), data.partners[Number(product.value)].variants.find(function (v) { return String(v.id) === partner.value; })];
    }
    function update() {
      var chosen = selection();
      var complete = chosen.every(Boolean);
      var amount = complete ? chosen[0].price + chosen[1].price : 0;
      total.textContent = complete ? money(amount) : '—';
      shipping.hidden = !(complete && data.country === 'US' && data.currency === 'USD' && amount >= 15000);
      status.textContent = '';
      syncControls();
    }
    function syncControls() {
      controls.forEach(function(c) {
        c.text.textContent = c.select.options[c.select.selectedIndex].text;
        c.button.disabled = c.select.disabled;
        c.button.setAttribute('aria-label', c.label + ': ' + c.text.textContent);
      });
    }
    function enhanceSelectors() {
      if (typeof HTMLDialogElement === 'undefined') return;
      var dialog = document.createElement('dialog');
      dialog.className = 'jjt-kit-picker';
      dialog.id = source.id + '-picker';
      var header = document.createElement('div');
      header.className = 'jjt-kit-picker__header';
      var heading = document.createElement('span');
      heading.id = dialog.id + '-title';
      dialog.setAttribute('aria-labelledby', heading.id);
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'jjt-kit-picker__close';
      close.setAttribute('aria-label', root.dataset.close);
      close.textContent = '×';
      header.append(heading, close);
      var context = document.createElement('p');
      context.className = 'jjt-kit-picker__context';
      var list = document.createElement('div');
      list.className = 'jjt-kit-picker__list';
      dialog.append(header, context, list);
      document.body.appendChild(dialog);
      var active;
      close.addEventListener('click', function(){dialog.close();});
      dialog.addEventListener('click', function(e){
        var box = dialog.getBoundingClientRect();
        if (e.target === dialog && (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom)) dialog.close();
      });
      dialog.addEventListener('close', function(){
        document.documentElement.classList.remove('jjt-kit-picker-open');
        if (active) { active.button.setAttribute('aria-expanded','false'); active.button.focus({preventScroll:true}); }
      });
      list.addEventListener('keydown', function(e){
        if (!['ArrowDown','ArrowUp','Home','End'].includes(e.key)) return;
        var buttons = Array.from(list.querySelectorAll('button'));
        var i = buttons.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        i = e.key === 'Home' ? 0 : e.key === 'End' ? buttons.length-1 : (i + (e.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[i].focus();
      });
      [source, product, partner].forEach(function(select){
        var label = root.querySelector('label[for="' + select.id + '"]');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'jjt-kit__select';
        button.id = select.id + '-trigger';
        button.setAttribute('aria-haspopup','dialog');
        button.setAttribute('aria-controls',dialog.id);
        button.setAttribute('aria-expanded','false');
        var text = document.createElement('span');
        text.className = 'jjt-kit__selected';
        var arrow = document.createElement('span');
        arrow.className = 'jjt-kit__chevron';
        arrow.setAttribute('aria-hidden','true');
        button.append(text,arrow);
        select.insertAdjacentElement('afterend',button);
        select.hidden = true;
        label.htmlFor = button.id;
        var control = {select:select,button:button,text:text,label:label.textContent.trim()};
        controls.push(control);
        button.addEventListener('click',function(){
          if (busy) return;
          active = control;
          heading.textContent = control.label;
          context.textContent = select === source ? data.source.title : select === partner ? data.partners[Number(product.value)].title : '';
          context.hidden = !context.textContent;
          list.replaceChildren();
          Array.from(select.options).forEach(function(option){
            if (!option.value) return;
            var item = document.createElement('button');
            item.type = 'button';
            item.className = 'jjt-kit-picker__option';
            item.setAttribute('aria-pressed',String(option.selected));
            if (select === product) {
              var p = data.partners[Number(option.value)];
              var image = document.createElement('img');
              image.src = p.image;
              image.alt = '';
              image.width = 64;
              image.height = 64;
              item.appendChild(image);
            }
            var name = document.createElement('span');
            name.textContent = option.text;
            item.appendChild(name);
            var check = document.createElement('span');
            check.className = 'jjt-kit-picker__check';
            check.setAttribute('aria-hidden','true');
            check.textContent = option.selected ? '✓' : '';
            item.appendChild(check);
            item.addEventListener('click',function(){
              select.value = option.value;
              select.dispatchEvent(new Event('change',{bubbles:true}));
              dialog.close();
            });
            list.appendChild(item);
          });
          dialog.showModal();
          document.documentElement.classList.add('jjt-kit-picker-open');
          button.setAttribute('aria-expanded','true');
          (list.querySelector('[aria-pressed="true"]') || list.querySelector('button') || close).focus({preventScroll:true});
        });
      });
      syncControls();
    }
    fillSizes(source, data.source.variants);
    data.partners.forEach(function (p, i) { product.add(new Option(p.title, String(i))); });
    function changePartner() {
      var p = data.partners[Number(product.value)];
      root.querySelector('[data-jjt-kit-partner-link]').href = p.url;
      var image = root.querySelector('[data-jjt-kit-partner-image]');
      image.src = p.image;
      image.alt = p.title;
      fillSizes(partner, p.variants);
      update();
    }
    changePartner();
    product.addEventListener('change', changePartner);
    source.addEventListener('change', update);
    partner.addEventListener('change', update);
    enhanceSelectors();
    add.addEventListener('click', async function () {
      if (busy || uncertain) return;
      var chosen = selection();
      if (!chosen.every(Boolean)) {
        status.textContent = data.copy.select_both;
        var missing = !chosen[0] ? source : partner;
        var control = controls.find(function(c){return c.select === missing;});
        (control ? control.button : missing).focus();
        return;
      }
      busy = true;
      [add, source, product, partner].forEach(function (el) { el.disabled = true; });
      syncControls();
      add.textContent = data.copy.adding;
      status.textContent = '';
      var response;
      try {
        response = await fetch(route + 'cart/add.js#jjt-kit', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:chosen.map(function(v){return {id:v.id,quantity:1};})})});
        if (!response.ok) {
          var failure = await response.json().catch(function(){return {};});
          status.textContent = typeof failure.description === 'string' ? failure.description : data.copy.error;
          return;
        }
        status.textContent = data.copy.added;
        if (window.JJTBagToast && window.JJTBagToast.openBag) window.JJTBagToast.openBag();
        else window.location.assign(route + 'cart');
      } catch (_) {
        uncertain = true;
        status.textContent = data.copy.uncertain;
        var link = document.createElement('a');
        link.href = route + 'cart';
        link.textContent = data.copy.view_bag;
        status.appendChild(document.createTextNode(' '));
        status.appendChild(link);
      } finally {
        busy = false;
        [source, product, partner].forEach(function(el){el.disabled=false;});
        syncControls();
        add.disabled = uncertain;
        add.textContent = data.copy.add;
      }
    });
    root.hidden = false;
  }
  function start() { document.querySelectorAll('[data-jjt-kit]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
}());
